import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {Alert} from 'antd';
import {List, WhiteSpace} from 'antd-mobile';
import OrderService from "../../apiServices/OrderService";

const Item = List.Item;

class OrderDetail extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('object_id');

        this.state = {
            hasError: false,
            object_id: object_id,
            order: null,
            userCar: null,
            orderItem: null
        };
    }

    componentDidMount() {
        if(this.state.object_id){
            OrderService.findByObjectId(this.state.object_id).then(response=>{
                this.setState({
                    order: response.data,
                    orderItem: JSON.parse(response.data.items),
                });
            }).catch(function(error){
                console.log(error);
            });
        }else{
            this.props.history.push('/');
        }
    }

    render() {
        let orderInfo;
        if (this.state.order){
            orderInfo = (<div>
                <List renderHeader={() => 'A. Người mua bảo hiểm'} className="od_header">
                    <Item className='od-title'>{this.state.order.full_name}</Item>
                    <Item extra={this.state.order.phone_no}>Điện thoại</Item>
                    <Item extra={this.state.order.district_name}>Quận huyện</Item>
                    <Item extra={this.state.order.province_name}>Thành phố</Item>
                    <Item wrap extra={this.state.order.address}>Địa chỉ</Item>
                </List>

                <List renderHeader={() => 'B. Thông tin xe'} className="od_header">
                    <Item extra={this.state.order.car_brand}>Hãng xe</Item>
                    <Item extra={this.state.order.car_product}>Dòng xe</Item>
                    <Item extra={this.state.order.plate_number}>Biển số xe</Item>
                    <Item extra={this.state.order.chassis_number}>Số khung</Item>
                    <Item extra={this.state.order.engine_number}>Số máy</Item>
                    <Item extra={this.state.order.car_year}>Năm sản xuất</Item>
                    <Item extra={this.state.order.car_number_seat + ' chỗ'}>Chỗ ngồi</Item>
                    <Item extra={Number(this.state.order.car_amount).toLocaleString('en')+'đ'}>Giá trị xe</Item>
                    <Item wrap extra={this.state.order.car_category}>Loại xe</Item>
                </List>

                <List renderHeader={() => 'C. Mua bảo hiểm cho ô tô'} className="od_header">
                    <Item extra={Number(this.state.order.car_amount).toLocaleString('en')+'đ'}>Giá trị xe tạm tính</Item>
                    <Item extra={Number(this.state.orderItem.value_contract).toLocaleString('en')+'đ'}>Mức bảo hiểm tối đa</Item>
                </List>

                <List renderHeader={() => 'D. Thông tin gói và phí bảo hiểm'} className="od_header">
                    <Item extra={Number(this.state.orderItem.base_fee).toLocaleString('en')+'đ / '+
                    this.state.orderItem.expire_contract+'tháng' }>1. Bảo hiểm vật chất xe</Item>
                    <Item extra={Number(this.state.orderItem.bs04_fee).toLocaleString('en')+'đ'}>2. BH Xe bị mất trộm, cướp bộ phận</Item>
                    <Item extra={Number(this.state.orderItem.bs05_fee).toLocaleString('en')+'đ'}>3. BH Lựa chọn cơ sở sửa chữa</Item>
                    <Item extra={Number(this.state.orderItem.bs13_fee).toLocaleString('en')+'đ'}>4. BH BH thiết bị lắp thêm</Item>
                </List>
                <List className={'orderBottomList'}>
                    <List.Item multipleLine extra={<div><List.Item.Brief>{Number(this.state.orderItem.ins_fee).toLocaleString('en')+'đ'}</List.Item.Brief>
                        <List.Item.Brief>{Number(this.state.orderItem.vat_fee).toLocaleString('en')+'đ'}</List.Item.Brief></div>}>
                        Phí bảo hiểm
                        <List.Item.Brief>Thuế VAT</List.Item.Brief>
                    </List.Item>
                    <List.Item className={'totalAmount'} extra={Number(this.state.orderItem.total_amount).toLocaleString('en')+'đ'}>Tổng phí bảo hiểm</List.Item>
                </List>
            </div>);
        }

        return (
            <div className='App-block'>
                <DefaultLayout {...this.props} title="Thông tin đăng ký bảo hiểm xe" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content">
                        <Alert
                            message="Cảm ơn bạn đã đăng ký gói bảo hiểm của chúng tôi,
                            khi bạn gặp bất cứ vấn đề gì của hợp đồng hay cần khiếu nại bồi thường,
                            hãy liên hệ với chúng tôi ngay!"
                            type="warning"
                        />
                        <WhiteSpace size='xl' />
                        {orderInfo}
                    </div>
                </DefaultLayout>
            </div>
        )
    }
}

export default (withTranslation())(OrderDetail);